// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch } from "antd";

// Import Styles
// import '../../assets/styles/containerStyles/appended-blog-section.scss';
// import '../../assets/styles/containerStyles/blog/blog-add-edit.scss';
import '../../assets/styles/containerStyles/page-add-edit.scss';
import '../../assets/styles/components/medias-list-wrapper.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import { InputGroup } from "../../components/uiElements/inputGroup";
import { LinkButton } from "../../components/buttons/buttons";
import { LanguageTabs } from "../../components/uiElements/Tabs";
import { Editor } from "../../components/uiElements/Editor";
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import { MediaFileCard } from "../../components/media/MediaFileCard";


// Import utils
import { mapStateToProps } from "../../redux/mapStateToProps";
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getPostReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import { AddBlog, GetBlogById, UpdateBlog, } from "../../redux/actions";
import { validateTranslations } from "../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../constants/acceptedTypes";
import { MEDIA_MODAL_TYPES, } from "../../constants/constTypes";
import Nestable from "react-nestable";
import { MaterialIcon } from "../../components/utils/Icon";

const BLOG_SOCIAL_ITEMS = {
    FACEBOOK: {
        key: "FACEBOOK",
        title: "FACEBOOK"
    },
    TWITTER: {
        key: "TWITTER",
        title: "TWITTER"
    },
    LINKEDIN: {
        key: "LINKEDIN",
        title: "LINKEDIN"
    },
    INSTAGRAM: {
        key: "INSTAGRAM",
        title: "INSTAGRAM"
    },
    TIKTOK: {
        key: "TIKTOK",
        title: "TIKTOK"
    },
    TELEGRAM: {
        key: "TELEGRAM",
        title: "TELEGRAM"
    },
}

const blogSocialOptions = Object.keys(BLOG_SOCIAL_ITEMS).map(key => {
    return {
        id: BLOG_SOCIAL_ITEMS[key].key,
        name: BLOG_SOCIAL_ITEMS[key].title,
    }
})

class AddEditBlog extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
            "creator",
            "duration",
            "label",
            "details",
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                coverMedia: undefined,
                medias: [],
                socials: [],
                slug: '',
                isHidden: false,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            mediaModalType: null,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.getPostReqData = getPostReqData.bind(this);

        this.toggleMediaModal = changeStateField.bind(this, 'mediaModalType');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);

        this.checkMediaListDifferent = this.checkMediaListDifferent.bind(this);
        this.onMediaPositionChange = this.onMediaPositionChange.bind(this);
        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);

        this.addSocialItem = this.addSocialItem.bind(this);
        this.deleteSocial = this.deleteSocial.bind(this);
        this.onSocialPositionChange = this.onSocialPositionChange.bind(this);

        this.addEditBlog = this.addEditBlog.bind(this);
    }

    async componentDidMount () {
        const { isEditing, fieldsData } = this.state;
        if (isEditing) {
            const translationsData = {};
            const editingData = await this.props.GetBlogById(this.props.id)
            // console.log(editingData);
            if (editingData) {
                Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = editingData?.translations?.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        title: trItem?.title || '',
                        description: trItem?.description || '',
                        details: trItem?.details || '',
                        creator: trItem?.creator || '',
                        duration: trItem?.duration || '',
                        label: trItem?.label || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                slug: editingData?.slug || '',
                type: editingData?.type || undefined,
                mediaMain: editingData?.mediaMain,
                coverMedia: editingData?.coverMedia,
                medias: editingData?.medias || [],
                socials: Array.isArray(editingData.socials) ? editingData.socials : [],
                isHidden: editingData?.isHidden,
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getMedia (mediaArray, mediaType) {
        const { fieldsData, errors, isEditing, mediaModalType } = this.state;
        if (isEditing) {
            if (mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN) {
                this.currentData?.[mediaModalType]?.id !== mediaArray[0]?.id
                    ? this.updatedDataMap.set(mediaModalType, mediaArray[0]?.id)
                    : this.updatedDataMap.delete(mediaModalType);
            } else {
                this.checkMediaListDifferent(mediaArray)
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [mediaModalType]: mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN
                    ? mediaArray[0] : mediaArray,
            },
            errors: {
                ...errors,
                [mediaModalType]: false
            }
        })
    }

    deleteMedia (type, id) {
        const { fieldsData, isEditing } = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            if (type === 'medias') {
                this.checkMediaListDifferent(medias)
            } else {
                this.currentData?.[type] ?
                    this.updatedDataMap.set(type, null) :
                    this.updatedDataMap.delete(type);
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: type === 'medias' ? medias : null
            }
        })
    }

    checkMediaListDifferent (currMedias) {
        let result = false;
        const initMedias = this.currentData.medias;
        if (!Array.isArray(currMedias) || (currMedias?.length !== initMedias.length)) {
            result = true;
        } else {
            currMedias.forEach((item, index) => {
                if (initMedias[index]?.id !== item?.id) {
                    result = true;
                }
            })
        }
        result ? this.updatedDataMap.set('medias', currMedias?.map(m => m.id))
            : this.updatedDataMap.delete('medias');
    }

    onMediaPositionChange (items) {
        const { fieldsData, isEditing } = this.state;
        const medias = items.map(item => item.media);
        if (isEditing) {
            // this.checkMediaListDifferent(medias)
            this.updatedDataMap.set('medias', medias?.map(m => m.id))
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: medias
            }
        })
    }

    mediaCardWrapper (data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={this.deleteMedia.bind(this, 'medias', data?.item?.media?.id)}/>
    }

    addSocialItem = () => {
        const { isEditing, } = this.state
        const socials = [{
            type: null,
            link: ''
        },
            ...this.state.fieldsData.socials]
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                socials: socials
            }
        })
    }

    deleteSocial (index) {
        const { isEditing, fieldsData, errors } = this.state;
        const socials = fieldsData.socials.filter((_, pos) => pos !== index)
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                socials: socials
            },
            errors: {
                ...errors,
                socials: {}
            }
        })
    }

    onSocialPositionChange = (items) => {
        // console.log('items', items)
        const { fieldsData, isEditing } = this.state;
        const socials = items.map(item => item.social);
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                socials
            }
        })
    }

    getSocialValue = (index, value, name) => {
        const { fieldsData, isEditing } = this.state;

        const socials = this.state.fieldsData.socials.map((item, pos) => {
            return pos === index ? {
                ...item,
                [name]: value
            } : item
        })
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                socials: socials
            }
        })
    }

    socialItem = (data) => {
        const { errors } = this.state
        const { index, social } = data.item
        return <div className={'social-item'}>
            <div className={`type-select ${errors?.socials?.[index + 'icon'] ? 'error' : ''}`}>
                <InputGroup inputType="selectCustom"
                            placeholder="Էջ"
                            label="Էջ"
                            name="type"
                            showSearch={false}
                            value={social?.type}
                            onChange={({ value }) => this.getSocialValue(index, value, 'type')}
                            options={blogSocialOptions}/>
            </div>
            <InputGroup inputType="input"
                        type="text"
                        label="Հղում"
                        placeholder="Հղում"
                        name="link"
                        value={social?.link}
                        maxLength={256}
                        error={errors?.socials?.[index + 'link']}
                        onChange={({ value }) => this.getSocialValue(index, value, 'link')}/>
            <div className={`delete-btn`} onClick={() => this.deleteSocial(index)}>
                <MaterialIcon icon="delete"/>
            </div>
        </div>
    }

    getSocialNestableItems = () => {
        const { fieldsData } = this.state
        const { socials } = fieldsData
        const items = [];
        socials && !!socials.length && socials.forEach((item, index) => {
            items.push({
                id: index,
                index: index,
                social: item
            })
        });
        return items;
    }

    async addEditBlog () {
        await this.setState({
            requestLoading: true
        });
        const { fieldsData } = this.state;
        const { translations, mediaMain, coverMedia, medias, socials, slug, isHidden } = fieldsData;
        const translationRequiredFields = ['title', 'description', 'creator', 'duration', 'label']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }
        if (!coverMedia) {
            errors.coverMedia = true;
            result = false;
        }

        if (!slug) {
            errors.slug = true;
            result = false;
        }
        errors.socials = {}
        socials && socials.forEach((social, index) => {
            if (!social.type) {
                errors.socials[index + 'type'] = true;
                result = false;
            }
            if (!social.link) {
                errors.socials[index + 'link'] = true;
                result = false;
            }
        })
        // console.log('result', result);
        if (result) {
            if (!this.state.isEditing) {
                const reqData = this.getPostReqData(fieldsData);
                reqData.isHidden = isHidden
                // console.log('reqData', reqData)
                this.props.AddBlog(reqData).finally(() => {
                    this.setState({ requestLoading: false });
                })
            } else {
                const trData = getTranslationData(translations);
                const reqData = this.getPatchReqData(trData);
                this.props.UpdateBlog(this.props.id, reqData)
                    .finally(() => {
                        this.setState({ requestLoading: false });
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalType,
            requestLoading,
            isEditing,
            errorsTabs
        } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};
        const mediaItems = [];
        fieldsData.medias.forEach(media => {
            mediaItems.push({
                id: media?.id,
                media: media
            })
        });
        let items = this.getSocialNestableItems();
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Բլոգ' : 'Փոփոխել Բլոգը'}>
            <section className="page-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար քարտ <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'mediaMain')}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                    <div>
                        <div className="top-side">
                            <label>Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.coverMedia ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'coverMedia')}
                            />
                        </div>
                        {fieldsData?.coverMedia && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.coverMedia}
                                           customDelete={() => this.deleteMedia("coverMedia")}
                            />
                        </div>}
                    </div>
                </div>
           {/*     <div className={'medias-list-wrapper'}>
                    <div className={'label-and-action'}>
                        <label>Նկարներ</label>
                        <LinkButton title="Ընտրել Մեդիադարանից"
                                    className={`media-select-btn `}
                                    cb={this.toggleMediaModal.bind(this, 'medias')}/>
                    </div>
                    <section className={'items-wrapper'}>
                        {mediaItems.length ? <Nestable
                                items={mediaItems}
                                maxDepth={1}
                                onChange={this.onMediaPositionChange}
                                renderItem={this.mediaCardWrapper}
                            /> :
                            <p className={'empty-text'}>Նկարներ չկան</p>}
                    </section>
                </div>*/}
                <InputGroup inputType="input"
                            type="text"
                            label="Slug"
                            placeholder="Slug"
                            name="slug"
                            value={fieldsData.slug}
                            initValue={this.currentData?.slug}
                            error={errors['slug']}
                            maxLength={50}
                            required={true}
                            onChange={this.getInputValues}/>
                <div className={'socials-wrapper'}>
                    <label>Սոցիալական հղումներ </label>
                    <div className={'add-row'}>
                        <LinkButton title="Ավելացնել"
                                    className={`media-select-btn`}
                                    cb={this.addSocialItem}/>
                    </div>
                    {items && items.length !== 0 &&
                    <Nestable
                        items={items}
                        maxDepth={1}
                        onChange={this.onSocialPositionChange}
                        renderItem={this.socialItem}
                    />}
                    {/*     {!!fieldsData.socials.length && fieldsData.socials.map(social=>{
                        return <div className={'social-item'}>

                        </div>
                    })}*/}
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div className="blog-wrapper">
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={256}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Ենթավերնագիր"
                                placeholder="Ենթավերնագիր"
                                name="description"
                                value={currentData.description}
                                initValue={initData.description}
                                error={errors['description' + languageTab]}
                                maxLength={1000}
                                required={true}
                                onChange={this.getTranslationValues}/>

                    <InputGroup inputType="input"
                                type="text"
                                label="Էջի Անվանում"
                                placeholder="Էջի Անվանում"
                                name="label"
                                value={currentData.label}
                                initValue={initData.label}
                                error={errors['label' + languageTab]}
                                maxLength={256}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Հեղինակ"
                                placeholder="Հեղինակ"
                                name="creator"
                                value={currentData.creator}
                                initValue={initData.creator}
                                error={errors['creator' + languageTab]}
                                maxLength={256}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Տևողություն"
                                placeholder="Տևողություն"
                                name="duration"
                                value={currentData.duration}
                                initValue={initData.duration}
                                error={errors['duration' + languageTab]}
                                maxLength={100}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <div className="editor-wrapper">
                        <label>Նկարագրություն</label>
                        <Editor value={currentData?.details || ''}
                                name={'details'}
                                initValue={initData?.details}
                                error={errors['details' + languageTab]}
                                onChange={this.getTranslationValues}/>
                    </div>

                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditBlog}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                mediaType={mediaModalType === "medias" ? MEDIA_MODAL_TYPES.MEDIA_ARRAY : MEDIA_MODAL_TYPES.MEDIA_MAIN}
                appendMedias={mediaModalType === "medias" && fieldsData.medias}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBlogById,
    AddBlog,
    UpdateBlog,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditBlog)
